var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWaterSports = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Swimming-Pool-Person--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Swimming Pool Person Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.07 14.07a2.15 2.15 0 0 0 1.49 0.93 2.8 2.8 0 0 0 1.89 -1 2.49 2.49 0 0 1 2 -1 2.51 2.51 0 0 1 2.27 1.42 1.27 1.27 0 0 0 1 0.63 1.84 1.84 0 0 0 1.47 -0.85 2.46 2.46 0 0 1 0.58 -0.66 0.24 0.24 0 0 0 0.05 -0.34l-4.54 -6.55a1.51 1.51 0 0 1 0.86 -2.33l3.92 -1a1.5 1.5 0 1 0 -0.73 -2.89l-3.92 1a4.5 4.5 0 0 0 -2.57 7l0.3 0.42 -5.5 3.78a0.25 0.25 0 0 0 -0.11 0.24 0.28 0.28 0 0 0 0.18 0.2 2.39 2.39 0 0 1 1.36 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.13 7.68a2.37 2.37 0 1 0 4.74 0 2.37 2.37 0 1 0 -4.74 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.56 18.45a5.82 5.82 0 0 0 3.81 -1.51 4.56 4.56 0 0 0 3.42 1.51A5.17 5.17 0 0 0 19.41 17a4.77 4.77 0 0 0 3.66 1.48 1 1 0 0 0 0.93 -1.11 1 1 0 0 0 -1.07 -0.93c-1.58 0.12 -2.67 -1.56 -2.68 -1.57a1 1 0 0 0 -1.71 0 3.38 3.38 0 0 1 -2.75 1.56A2.82 2.82 0 0 1 13.38 15a1 1 0 0 0 -1.72 -0.16 4.27 4.27 0 0 1 -3.1 1.64 3.55 3.55 0 0 1 -2.76 -1.61 1 1 0 0 0 -1.64 -0.09s-1.46 1.82 -3.11 1.7a1 1 0 0 0 -1 0.95 1 1 0 0 0 1 1.05h0.22A5.86 5.86 0 0 0 5 16.88a5.24 5.24 0 0 0 3.56 1.57Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.93 21.57c-1.58 0.12 -2.67 -1.56 -2.68 -1.57a1 1 0 0 0 -1.71 0 3.36 3.36 0 0 1 -2.75 1.56 2.82 2.82 0 0 1 -2.41 -1.48 1 1 0 0 0 -1.72 -0.16 4.27 4.27 0 0 1 -3.1 1.64A3.55 3.55 0 0 1 5.8 20a1 1 0 0 0 -1.64 -0.09s-1.51 1.82 -3.11 1.7a1 1 0 0 0 -1 0.95 1 1 0 0 0 1 1.05 5.83 5.83 0 0 0 4 -1.6 5.24 5.24 0 0 0 3.66 1.57 5.87 5.87 0 0 0 3.81 -1.5 4.59 4.59 0 0 0 3.42 1.5 5.17 5.17 0 0 0 3.62 -1.5 4.84 4.84 0 0 0 3.66 1.49A1 1 0 0 0 24 22.5a1 1 0 0 0 -1.07 -0.93Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWaterSports);
export default ForwardRef;